import script from "./center-top.vue?vue&type=script&setup=true&lang=js"
export * from "./center-top.vue?vue&type=script&setup=true&lang=js"

import "./center-top.vue?vue&type=style&index=0&id=56d1e714&scoped=true&lang=stylus"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56d1e714"]])

export default __exports__